export interface QuickThoughtsTrialPitchTimings {
  barQuietProbability: number;
  barTickMs: number;
  captureInMs: number;
  captureTransitionMs: number;
  coreTransitionMs: number;
  divider1InMs: number;
  divider2InMs: number;
  dividerFadeMs: number;
  message1InMs: number;
  message2InMs: number;
  message3InMs: number;
  messageTransitionMs: number;
  recedeInMs: number;
  releaseInMs: number;
  releaseTransitionMs: number;
  recordingInMs: number;
  sheetCardTransitionMs: number;
  sheetInMs: number;
  sheetEasing: string;
  sheetScrimMs: number;
  sheetSlideMs: number;
  spinnerRevolutionMs: number;
  transcriptFadeMs: number;
  transcriptInMs: number;
  typedAcknowledgementInMs: number;
  typedSheetInMs: number;
  typedUserMessageInMs: number;
  wordMs: number;
}

/** Editable choreography for the quick-thoughts trial pitch. */
export const DEFAULT_QUICK_THOUGHTS_TRIAL_PITCH_TIMINGS: QuickThoughtsTrialPitchTimings = {
  barQuietProbability: 0.22,
  barTickMs: 95,
  captureInMs: 400,
  captureTransitionMs: 600,
  coreTransitionMs: 300,
  divider1InMs: 5_500,
  divider2InMs: 8_900,
  dividerFadeMs: 550,
  message1InMs: 6_100,
  message2InMs: 7_500,
  message3InMs: 9_700,
  messageTransitionMs: 500,
  recedeInMs: 4_700,
  releaseInMs: 3_600,
  releaseTransitionMs: 450,
  recordingInMs: 1_300,
  sheetCardTransitionMs: 700,
  sheetInMs: 4_850,
  sheetEasing: "cubic-bezier(.22, .9, .3, 1)",
  sheetScrimMs: 300,
  sheetSlideMs: 380,
  spinnerRevolutionMs: 900,
  transcriptFadeMs: 400,
  transcriptInMs: 1_650,
  typedAcknowledgementInMs: 2_100,
  typedSheetInMs: 450,
  typedUserMessageInMs: 1_150,
  wordMs: 150,
};
